<div id="main" [style.margin-left.%]="18">
  <iframe width="1000" height="1005" frameborder="0"
          src="https://app.smartsheet.com/b/form/1bb5b3b123994e08b51fe10d92748649"></iframe>
</div>